<template>
  <div>
    <div class="p-4 font-medium max-h-96 overflow-auto bg-charcoal-100 dark:bg-dark-950">
      <p class="font-bold text-xl -mt-0.5">
        {{ $t('components.Event.review.place.title', { name: place?.name ?? ''}) }}
      </p>

      <p>{{ $t('components.Event.review.place.content') }}</p>
      
      <div class="bg-white dark:bg-dark-800 dark:text-dark-50 rounded-xl text-light-950 shadow mt-4 overflow-hidden">
        <PlaceSafeRatingFormSteps :place="place" class="py-4 px-1" @end="() => emit('next')" v-if="place" />
      </div>
    </div>

    <div class="bg-white border-t border-charcoal-200 dark:border-dark-600 dark:bg-dark-800 flex items-center space-x-2 p-2.5">
      <ButtonBase style-type="round" class="shrink-0" color="white" @click="() => emit('previous')">
        <IconBase name="cute/angle-right" class="rotate-180" :width="20" />
      </ButtonBase>

      <ButtonBase color="white" is-full :is-loading="isLoading" :is-disabled="Object.keys(formData).length <= 0" @click="onNext">
        {{ $t('actions.skip') }}
      </ButtonBase>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Event } from '@/classes'
import EventStore from '@/store/events'
import UserStore from '@/store/user'
import PlacesStore from '@/store/places'
import { EVENT_REVIEW_TAGS } from '@/static/events'
import { InAppReview } from '@capacitor-community/in-app-review'

const props = withDefaults(defineProps<{
  event: Event
}>(), {

})

const { event } = toRefs(props)

const eventStore = EventStore()
const userStore = UserStore()
const placesStore = PlacesStore()
const { currentUser } = storeToRefs(userStore)

const place = computed(() => placesStore.getItem(event.value.place ?? ''))

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'previous'): void
  (e: 'reset'): void
}>()

const formData: Ref<{
  tags: (keyof typeof EVENT_REVIEW_TAGS)[]
  kudos: string[]
}> = ref({
  tags: [],
  kudos: []
})

const isLoading = ref(false)

const onNext = async () => {
  isLoading.value = true

  await eventStore.review(props.event._id, formData.value)

  if (Math.random() < 0.5) InAppReview.requestReview()

  isLoading.value = false
}

</script>